import { render, staticRenderFns } from "./TemporaryUser.vue?vue&type=template&id=06c166a3&scoped=true&"
import script from "./TemporaryUser.vue?vue&type=script&lang=js&"
export * from "./TemporaryUser.vue?vue&type=script&lang=js&"
import style0 from "./TemporaryUser.vue?vue&type=style&index=0&id=06c166a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c166a3",
  null
  
)

export default component.exports